// Types
import {
  AuthConfiguration,
  EnvironmentVariables,
  RecaptchaConfiguration,
} from '../types/next-env';
import {
  CountryCode,
  ISOLanguageKeys,
  ServerSideLanguageKeys,
} from '../types/language';

export const authentication: AuthConfiguration = {
  NEXTAUTH_URL: process.env.NEXTAUTH_URL ?? '',
  NEXTAUTH_SECRET: process.env.NEXTAUTH_SECRET ?? '',

  APIM_SUBSCRIPTION_KEY: process.env.APIM_SUBSCRIPTION_KEY ?? '',

  ADB2C_AUTHORITY: process.env.ADB2C_AUTHORITY ?? '',
  ADB2C_DOMAIN_NAME: process.env.ADB2C_DOMAIN_NAME ?? '',
  ADB2C_SIGNOUT_URL: process.env.ADB2C_SIGNOUT_URL ?? '',
  ADB2C_SCOPE_BASE_URL: process.env.ADB2C_SCOPE_BASE_URL ?? '',
  ADB2C_TENANT_BASE_ID: process.env.ADB2C_TENANT_BASE_ID ?? '',
  ADB2C_TENANT_FULL_ID: process.env.ADB2C_TENANT_FULL_ID ?? '',
  ADB2C_ACCESS_TOKEN_URL: process.env.ADB2C_ACCESS_TOKEN_URL ?? '',
  ADB2C_APP_REGISTRATION_SCOPE_ID:
    process.env.ADB2C_APP_REGISTRATION_SCOPE_ID ?? '',
  ADB2C_APP_REGISTRATION_CLIENT_ID:
    process.env.ADB2C_APP_REGISTRATION_CLIENT_ID ?? '',
};

export const defaultEnv: EnvironmentVariables = {
  Auth: authentication,
  ApiUrl: process.env.API_URL ?? '',
  CountryCode: (process.env.COUNTRY_CODE as CountryCode) ?? 'GB',
  LanguageId: (process.env.LANGUAGE_ID as ServerSideLanguageKeys) ?? 'en_GB',
  DefaultLanguage: (process.env.DEFAULT_LANGUAGE as ISOLanguageKeys) ?? 'en-GB',
};

export const recaptcha: RecaptchaConfiguration = {
  RecaptchaKey: process.env.RECAPTCHA_SITE_KEY ?? '',
  MaxRecaptchaAttempts: Number(process.env.MAX_RECAPTCHA_ATTEMPTS ?? 0),
};
